import React, {Component} from 'react';
import {Link} from "react-router-dom";
import { Badge } from 'reactstrap';

class ListNotificationComponent extends Component {

    checkedNotification = (e) => {
        // console.log("da den")
        // this.props.checkedNotification( this.props.actionKey );
        if ( e.nativeEvent.shiftKey ) {
            let value = e.target.checked;
            console.log('shiftKey');
            this.props.checkedNotiShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedNotification( this.props.actionKey );
        }
    }

    createMarkup = (title) => {
        return (
              title.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, "")
        )
    }

    render() {
        return (
            <tr>
                <td>
                    <input 
                        type="checkbox" 
                        checked={ this.props.notification.checked } 
                        onChange={ this.checkedNotification } 
                    />
                </td>
                <td>
                    <Link to={"/thong-bao/" + this.props.notification.notification_id + "/chi-tiet-thong-bao.html"}>
                        { this.props.notification.text_created_at }
                    </Link>
                </td>
                <td className="text-left pl-4">
                    <Link to={"/thong-bao/" + this.props.notification.id + "/chi-tiet-thong-bao.html"}>
                        {
                            this.createMarkup(this.props.notification.title)
                        }
                        {
                            this.props.notification.read_at === null ? (
                                <Badge className="ml-2" color="secondary">
                                    Mới
                                </Badge>
                            ) : (
                                <></>
                            )
                        }
                    </Link>
                </td>
            </tr>
        );
    }
}

export default ListNotificationComponent;